import { ReactComponent as Mobile } from '../../assets/svgs/howToUse/mobile.svg';
import { ReactComponent as Money } from '../../assets/svgs/howToUse/money.svg';
import { ReactComponent as Download } from '../../assets/svgs/howToUse/download.svg';
import { ReactComponent as Search } from '../../assets/svgs/howToUse/search.svg';


export default [
  {title: 'Contrate online', description: 'Contrate pelo nosso site o plano para você e seus dependentes.', step: 1, icon: Mobile,},
  {title: 'Efetue seu pagamento', description: 'Efetue o pagamento através do seu Cartão de Crédito, Boleto Bancário, Pic Pay ou Ame Digital.', step: 2, icon: Money,},
  {title: 'Baixe nosso App', description: 'Instale nosso App no seu celular para ter acesso a carteirinha digital.', step: 3, icon: Download,},
  {title: 'Procure um Dentista', description: 'Localize na nossa rede credenciada a melhor opção e agende sua primeira consulta,', step: 4, icon: Search,},
]